module.exports = __webpack_public_path__ + "static/media/07_FamiliePaschy_webfinal.24bcfdfa.jpg";